import request from "@/utils/request";

//获取用户角色菜单 管理
export function getRoleMenuByUserId(userId) {
  return request({
    url: `/app/zhkt/role/v1/getRoleMenuByUserId?userId=${userId}`,
    method: "get",
  });
}

//查询导航菜单列表
export function navigation(data) {
  return request({
    url: `/app/zhkt/navigation/v1/homeNavigations`,
    method: "post",
    data: data,
  });
}
